import './data_formatter.js.coffee';# Added by Script 
Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.HierarchicalAttributeDataFormatter extends CustomerVisualMode.Charts.DataFormatter
  _translatedData: (widget, data) ->
    translatedData = super(widget, data)
    translatedData = translatedData.concat(@_deletedValuesItem(data)) if data.deleted?
    translatedData

  _deletedValuesItem: (data) ->
    {
      name: I18n.t 'customer_visual_mode.charts.single_dimension.deleted_values'
      value: data.deleted
      id: 'deleted values'
    }
